import { defineStore } from "pinia";

import type { AuthUser } from "@/domain/Auth/domain/models/AuthUser";
import { HttpAuthRepository } from "@/domain/Auth/infrastructure/repositories/HttpAuthRepository";

export const useAuthStore = defineStore("auth", {
  state: () => ({
    isAuthenticated: localStorage.getItem("isAuthenticated") ? JSON.parse(localStorage.getItem("isAuthenticated")!) : false,
    user: JSON.parse(localStorage.getItem("user") ?? "null") as AuthUser | null,
    token: localStorage.getItem("token") as string | null,
    expiresAt: localStorage.getItem("expiresAt") as string | null,
  }),
  actions: {
    setAuthData(data: { token: string; expires_at: string }, user: AuthUser | null): void {
      this.isAuthenticated = true;
      this.token = data.token;
      this.user = user;
      this.expiresAt = data.expires_at;
      localStorage.setItem("token", data.token);
      localStorage.setItem("isAuthenticated", "true");
      localStorage.setItem("user", JSON.stringify(user));
      localStorage.setItem("expiresAt", data.expires_at);
    },
    clearAuthData(): void {
      this.isAuthenticated = false;
      this.token = null;
      this.user = null;
      this.expiresAt = null;
      localStorage.setItem("isAuthenticated", "false");
      localStorage.setItem("token", "null");
      localStorage.setItem("user", "null");
      localStorage.setItem("expiresAt", "null");
      localStorage.clear();
    },
    async refreshToken(): Promise<void> {
      try {
        const repository = new HttpAuthRepository();
        const response = await repository.refreshToken();
        this.setAuthData(response.data, this.user);
      } catch (error) {
        console.error("Token refresh failed:", error);
        this.clearAuthData();
        throw error;
      }
    },
  },
});
